import { defineComponent, inject, onMounted, onUnmounted } from 'vue';
import FacebookButton from './FacebookSigninButton.class';
import { setupComponent } from "@studyportals/vue-platform";
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';

export default defineComponent({
	props: {
		template: String,
		isRegistration: {
			type: Boolean,
			default: true
		}
	},

	setup: (props) => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if(!store) throw new Error('IncentiveV2Store not provided');
		const component = new FacebookButton(store, props.isRegistration, props.template as string);

		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmount.bind(component));

		return setupComponent(component);
	},
});
